import React from "react";
import { MapPin } from "lucide-react";

export default function Coverage({ t }) {
  // Google Maps embed for Rogaland (no API key needed)
  const mapSrc =
    "https://www.google.com/maps?q=Rogaland,Norway&z=8&output=embed";

  return (
    <section id="coverage" className="bg-[#F4F4F5] border-b-2 border-black" data-testid="coverage-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.coverage.eyebrow}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
            {t.coverage.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-zinc-700 max-w-xl leading-relaxed">
            {t.coverage.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap gap-2" data-testid="coverage-cities">
            {t.coverage.cities.map((c, i) => (
              <span
                key={c}
                className="inline-flex items-center gap-2 border-2 border-black bg-white px-3 py-2 text-sm font-semibold"
                data-testid={`coverage-city-${i}`}
              >
                <MapPin size={14} className="text-[#E11D2E]" /> {c}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="border-2 border-black overflow-hidden h-[420px] md:h-[500px] relative brutal-shadow" data-testid="coverage-map-wrap">
            <iframe
              title="Rogaland kart — Raskt Hjem AS"
              src={mapSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
              style={{ border: 0, filter: "grayscale(0.15) contrast(1.05)" }}
              data-testid="coverage-map-iframe"
            />
            <div className="absolute top-4 left-4 bg-black text-white px-3 py-2 border-2 border-[#E11D2E] font-display text-xl pointer-events-none">
              ROGALAND
            </div>
            <div className="absolute bottom-4 right-4 bg-[#E11D2E] text-white px-3 py-2 border-2 border-black text-[10px] font-bold tracking-[0.22em] pointer-events-none">
              VI DEKKER HELE FYLKET
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
